import { useState, type ReactElement, useEffect } from "react";
import "../style.less";
import useAxios from "../../shared/custom-hooks/useAxios";
import { useAppState } from "../../lib/appContext/AppContext";
import PlatFormAPIAxiosInstance from "../../shared/utils/platFormAxios";
import {
  applyOrgLiecningToOrgs,
  orgLicencing,
} from "../../shared/utils/orgLicencingUtil";
import { EntitiesHallPlatform } from "./EntitiesHallPlatform";

const HallOfEntities = (): ReactElement => {
  const { response } = useAxios("/orgs?attributes=workspaces", true);
  const [licencingData, setLicencingData] = useState<any>([]);
  const [licencingStatus, setLicencingStatus] = useState({});
  const { setStateValue } = useAppState();

  useEffect(() => {
    if (response?.content?.length) {
      getLicencingData();
    }
  }, [response]);

  useEffect(() => {
    if (licencingData.length) {
      const licencingStatusData = orgLicencing(response, licencingData);
      setLicencingStatus(licencingStatusData);
    }
  }, [licencingData]);

  useEffect(() => {
    const licencingAppliedOrgs: any = applyOrgLiecningToOrgs(
      response,
      licencingStatus
    );
    setStateValue({
      orgsData: licencingAppliedOrgs,
      workspaceValue: null,
      orgValue: null,
      farmValue: null,
      assigneeValue: null,
    });
  }, [licencingStatus]);

  const getLicencingData = (): void => {
    const licencingIds = new Set<string>(
      response?.content.map((org: any) => {
        return org.licensing_account_id;
      })
    );
    const licencingDataResponse = Array.from(licencingIds).map(
      async (id: string) => {
        const lDataPromise = await PlatFormAPIAxiosInstance.get(
          `/licensing/accounts/${id}`
        );
        return lDataPromise;
      }
    );

    Promise.all(licencingDataResponse)
      .then((values) => {
        const licencingResp = values.map((lData) => {
          return lData?.data;
        });
        setLicencingData(licencingResp);
      })
      .catch((err) => {
        console.error("Error Occurred", err);
      });
  };

  return (
    <div className="hall-of-org-main">
      <EntitiesHallPlatform />
    </div>
  );
};

export default HallOfEntities;
